import api from '../api';

export default class GrausInstrucoesService {
  constructor() {
    throw 'Não é possível instanciar GrausInstrucoesService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `graus-instrucoes`;
};



// WEBPACK FOOTER //
// ./src/services/enums/grausInstrucoesService.js